import React, {PureComponent} from "react";
import {IReducerState} from "../../../../states/renditionStates";
import {connect} from "react-redux";
import * as asyncStateAction from "../../../../actions/asyncStateAction";
import serviceConfig from "../../../../services/servicesConfig";
import ReactDOM from 'react-dom';
import * as deviceInfoService from '../../../../utils/general/deviceInfoService';
import _ from 'lodash';
import $ from "jquery";
import { enterKeyPressed } from '../../../../utils/general/enterKey';
import { isVisible } from '../../../../utils/general/enterKey';
import * as HTML_RENDITION from '../../../../utils/general/general';

let focusable: any = null;
let firstFocusable: any = null;
let lastFocusable: any = null;

interface IMustReadContentFunctionalProps {
    loadMustReadSectionData: (documentId: string, isJP: boolean) => {};
}

interface IMustReadContentVariableProps {
    docHeaderSectionJson: any;
    mustReadSectionData: any;
}

interface IMustReadContentProps extends IMustReadContentVariableProps, IMustReadContentFunctionalProps {
    getTarget: any;
}

export class MustReadContent extends PureComponent<IMustReadContentProps, any> {

    constructor(props: IMustReadContentProps) {
        super(props);
        const metadata = this.props.docHeaderSectionJson.metadata;
        this.props.loadMustReadSectionData(metadata?.MustReadSection?.docId, metadata?.isJP);
    }

    public componentDidMount() {
        this.handleThrottle();
        window.addEventListener('resize', _.throttle(_.bind(this.handleThrottle, this), 200));
        setTimeout(() => {
            $('#modalClose').focus();
            this.setFocusableElements();
            $('#mustReadModal').keydown(this.handleKeyDown);
          }, 500);
    }

    public componentWillUnmount() {
        window.addEventListener('resize', _.throttle(_.bind(this.handleThrottle, this), 200));
    }

    public setFocusableElements() {
        const candidateSelectors = ['input', 'select', 'textarea', 'a[href]', 'button', '[tabindex]:not([tabindex="-1"])', 'audio[controls]', 'video[controls]', '[contenteditable]:not([contenteditable="false"])', 'details>summary:first-of-type', 'details'];
        const candidateSelector = candidateSelectors.join(',');
        const ele = document.querySelector("#mustReadModal");
        focusable = ele && ele.querySelectorAll(candidateSelector);

        const focusableElements = [];
        for (let i = 0; i < focusable.length; i++) {
          const node = focusable[i];
          if (isVisible(node)) {
            focusableElements.push(node);
          }
        }
        focusable = focusableElements;
        firstFocusable = focusable[0];
        lastFocusable = focusable[focusable.length - 1];

        if (firstFocusable) {
          firstFocusable.focus();
        }
    }

    public handleKeyDown(e: any) {
      let cancel = false;
      if (e.ctrlKey || e.metaKey || e.altKey) {
          return;
      }
      switch (e.which) {
          case 27: // ESC
            $('#modalClose').click();
            cancel = true;
            $('#financials-must-read-forecast').focus();
            break;
          case 9: // TAB
            if (e.shiftKey) {
              if (document.activeElement === firstFocusable) {
                lastFocusable.focus();
                cancel = true;
              }
            } else {
              if (document.activeElement === lastFocusable) {
                firstFocusable.focus();
                cancel = true;
              }
            }
            break;
      }
      if (cancel) {
          e.preventDefault();
      }
    }
    public handleThrottle() {
        const target: any = $(this.props.getTarget);
        const getLeft = deviceInfoService.isDeviceScreenType() ? 0 : (target.offset().left - 300);
        $('#mustReadModal').css({'left': getLeft});
    }

    public render() {
        const mustReadSectionData = this.props.mustReadSectionData;
        const docHeaderSectionJson = this.props.docHeaderSectionJson;
        if (_.isEmpty(mustReadSectionData)) {
            return null;
        }
        this.handleMustReadModal(mustReadSectionData, docHeaderSectionJson);
        return <React.Fragment></React.Fragment>;
    }

    private  goToMustReadPublication = (renditionUrl: string, event: any) => {
        event.preventDefault();
        event.stopPropagation();

        if (_.isEmpty(renditionUrl)) {
            return;
        }

        if (HTML_RENDITION.isBloomBerg()) {
            HTML_RENDITION.checkDocIdAndOpenPubicationForBBGWithDocumentURL(renditionUrl, true);
        } else if (HTML_RENDITION.isThirdPartyTokenAuthorization()) {
            HTML_RENDITION.executeWindowOpenForEPFToken(renditionUrl);
        } else {
            const target = HTML_RENDITION.isAppInsideCVResearchUIiFrame() ? "_self" : "_blank";
            window.open(renditionUrl, target);
        }
    }

    private getHeadline(mustReadSectionData: any) {
        const headline = mustReadSectionData.docHeadline;
        let renditionUrl = '';
        if (!_.isEmpty(mustReadSectionData.renditionLink)) {
            renditionUrl = mustReadSectionData.renditionLink;
        }
        return (<a tabIndex={0} role="link" className="mustread-headline" onClick={(e) => this.goToMustReadPublication(renditionUrl, e)} href={renditionUrl}>{headline}</a>);
    }

    private getSummary(docHeaderSectionJson: any) {
        const metaData = docHeaderSectionJson.metadata["MustReadSection"];
        if (metaData.summary) {
            const summary = metaData.summary;
            return (<div dangerouslySetInnerHTML={{__html: summary}}></div>);
        }
        return (<div></div>);
    }

    private getAuthorName(mustReadSectionData: any) {
        if (mustReadSectionData.authorName) {
            const authorName = mustReadSectionData.authorName;
            return (<div className="mustread-section"><span>{authorName}</span></div>);
        }
        return (<div></div>);
    }

    private closeModal() {
        $('#modalClose').click();
        $('#mustReadModal').remove();
        $('#common-modal-backdrop').remove();
        $('#financials-must-read-forecast').focus();
    }

    private handleMustReadModal(mustReadSectionData: any, docHeaderSectionJson: any) {
        const target: any = $(this.props.getTarget);
        if (!document.getElementById('mustReadModal')) {
            const newdiv = document.createElement('div');           // create mustRead modal container
            const att = document.createAttribute("id");
            att.value = "mustReadModal";
            const getLeft = deviceInfoService.isDeviceScreenType() ? 0 : (target.offset().left - 300);
            const top = $(window).scrollTop() || 0;
            const getTop = target.offset().top - top + 40;

            newdiv.style.left = getLeft + 'px';
            newdiv.style.top = getTop + 'px';
            newdiv.setAttributeNode(att);

            const backDrop: any = document.createElement('div');    // create the background mask for the modal
            const backDropAtt = document.createAttribute("id");
            backDropAtt.value = "common-modal-backdrop";
            backDrop.setAttributeNode(backDropAtt);

            document.body.appendChild(newdiv);
            document.body.appendChild(backDrop);

            const mustReadContainer = [];
            const container =
                (
                    <div className="mustread-section">
                        <div tabIndex={0} id="modalClose" onClick={() => this.closeModal()} aria-label="Close Dialog" role="button"
                             onKeyPress={(e) => enterKeyPressed(e, this.closeModal.bind(this, e))}>
                        </div>
                        <div className="mustread-headline">
                            {this.getHeadline(mustReadSectionData)}
                        </div>
                        <div className="mustread-summary">
                            {this.getSummary(docHeaderSectionJson)}
                            {this.getAuthorName(mustReadSectionData)}
                        </div>
                    </div>
                );
            mustReadContainer.push(container);
            ReactDOM.render(mustReadContainer, document.getElementById('mustReadModal'));
        }

        $('#common-modal-backdrop').click(() => {
            this.closeModal();
        });
    }
}

const mapStateToProps = (state: IReducerState) => {
    return {
        docHeaderSectionJson: state.asyncStateReducer.docHeaderJsonData,
        mustReadSectionData: state.asyncStateReducer.mustReadSectionData
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        loadMustReadSectionData: (documentId: string, isJP: boolean) =>
            dispatch(asyncStateAction.fetchMustReadSectionData(
                serviceConfig.GET_MUST_READ_SECTION, documentId, isJP
            ))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MustReadContent);
